/* global document, window */
const parallax = document.querySelector('.js-parallax');
const cover = document.querySelector('.js-cover');

if (cover && parallax) {
	window.addEventListener('scroll', () => {
		parallax.style.top = `${-1 * (cover.getBoundingClientRect().height + window.scrollY / 4)}px`;
	});
}
